import React, { useState } from "react";
import { AssessementContext } from "../../../AssessmentContext";
import { useNavigate, Link } from "react-router-dom";
import { defaultState } from "../../../components/defaultState";
import { api } from "./../../../../../../api/index";
import ReactStars from "react-rating-stars-component";
import { useQuery } from "react-query";
import { toast } from "react-hot-toast";
import { useCustomToast } from "../../../../../../components/customtoast/CustomToastProvider";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const CompletedAssessmentModal = () => {

  const { assessment, setAssessment } = React.useContext(AssessementContext);
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(10);
  const [autoMove, setAutoMove] = useState(false)
  const [feedback, setFeedback] = useState([]);
  const [errorMessage, setErrorMessage] = useState('')
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.traslation.language);

  const { data: feedbackQuestion, refetch, isLoading } = useQuery(
    "get feedback questions",
     () => api.getFeedbackQuestions({ language: currentLanguage }),
    {
      onSuccess: data => {
        const initialFeedback = data?.data?.map(question => ({
          id: question.id,
          response: null,  
          text: question?.text
        }));
          setFeedback(initialFeedback);
      }
    }
  );

   
  const closeModal = (navigation) => {
    setAssessment(defaultState);
    if (navigation === "history") navigate("/candidate/exam-history");
    else navigate("/candidate/assessments/view-assessments");
    document.exitFullscreen();
  };


  const customToast = useCustomToast();
  const [rating, setRating] = useState(0);
  const [text, setText] = useState("");
  const [answers, setAnswers] = useState({
    q1: null,
    q2: null,
    q3: null,
    q4: null,
    q5: null,
  });

  const handleRadioChange = (questionId, response) => {
    setFeedback(prevFeedback => (
      prevFeedback.map(item => (
        item.id === questionId ? { ...item, response } : item
      ))
    ));
  };

  const ratingLabel = (rating) => {
    if (rating == 0.5 || rating == 1) {
      return t('rating-bad');
    } else if (rating == 1.5 || rating == 2) {
      return t('rating-fair');
    } else if (rating == 2.5 || rating == 3) {
      return t('rating-good');
    } else if (rating == 3.5 || rating == 4) {
      return t('rating-very-good');
    } else {
      return t('rating-excellent');
    }
  };

  const ratingChanged = (newRating) => {
    setRating(newRating);
    
    let label = "";
    if (newRating == 0.5 || newRating == 1) {
      label = "Bad";
    } else if (newRating == 1.5 || newRating == 2) {
      label = "Fair";
    } else if (newRating == 2.5 || newRating == 3) {
      label = "Good";
    } else if (newRating == 3.5 || newRating == 4) {
      label = "Very Good";
    } else {
      label = "Excellent";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let content = {
      comment: text,
      rating: rating,
    };
    const feedbackSubmitted = feedback.filter( feedback => {
       return feedback?.response !== null
    } )
    if(feedbackSubmitted?.length){          
         setErrorMessage('')
         const feedbackQuestions = feedbackSubmitted.filter( question => question.response !== null )
         try {
          toast.loading(t('sending-feedback'));          
          const res = await api.sendFeedback({ 
                ...content, 
                questions: feedbackQuestions.map( question => {
                  return { id: question?.id, response: question?.response }
                })
           });
          toast.remove();
          customToast.success(res.message);
          navigate("/candidate/exam-history");
        } catch (error) {
          customToast.error(error.response.data.error);
          toast.remove()
        }
    }
    else setErrorMessage(t('no-feedback'))     
  };

  const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');
const assessmentType = sessionStorage.getItem('assessment-type')

  return (
    <div
      className="h-[100vh] w-[100vw] bg-[#eee] fixed top-0 left-0 grid place-items-center p-3 md:p-16"
      style={{ zIndex: 9000000 }}
    >  
      <div className="w-full h-full md:w-[60%] flex items-center justify-center ">
        <div className={`${ !autoMove ? 'h-[100vh] w-full': 'h-[350px] md:h-[500px] w-full md:w-[40vw] '}  bg-white h-auto rounded-lg p-8`}>
         <div className="flex justify-end items-end">
             
         </div>  
          <div className="flex justify-center">
            <div className="flex flex-col mb-10">
              <div className="flex justify-between items-center">
                <div> 
                  { <img 
                    src="/images/checklist-with-box-and-green-label-check-mark-for-assignment-or-exam-results-vector.jpg" 
                     alt="sucessful exam image"
                     className="block w-[250px] h-[250px] mt-0 mx-auto mb-2" 
                  />}
                  <h3 className="text-primary font-semibold text-2xl mb-0 text-center">
                    {assessmentType === 'survey' ? 'Survey' : 'Review'} Completed Successfully!
                  </h3>
                </div>
              </div>
            </div>
          </div>
          {  <>
          <p className="font-semibold text-center text-base text-darkBlue mb-9">
              you had successfully completed your 
              {assessmentType === 'survey' ? 'survey journey' : `review for ${
                 JSON.parse(sessionStorage.getItem('active-assessment'))?.user_name
                }`}
            </p>
          </>} 
          <Link
            to={
              assessmentType === 'survey'
                ? "/candidate/dashboard"
                : "/candidate/my-review"
            }
            className="font-semibold text-center text-base w-[200px] py-3 rounded-lg mx-auto text-white bg-primary mb-9"
          >
            Return to Dashboard
          </Link>
        </div>
        </div>
    </div>
  );
};

export default CompletedAssessmentModal;
